export default function slideInPanel({ title, $content }) {
    const $panel = document.createElement('div');
    const $header = document.createElement('div');
    const $title = document.createElement('h2');
    const $body = document.createElement('div');
    const $close = document.createElement('button');
    const OPEN_CLASS = 'slide-panel-open';

    const open = () => requestAnimationFrame(() => document.body.classList.add(OPEN_CLASS));

    const close = () => {
        $panel.addEventListener('transitionend', () => $panel.remove());

        document.body.classList.remove(OPEN_CLASS);
    };

    $panel.classList.add('slide-panel');
    $header.classList.add('slide-panel-header');
    $body.classList.add('slide-panel-body');
    $close.classList.add('plain', 'button', 'close');
    $title.classList.add('h4');

    $close.innerHTML = '<span class="icon"><span class="sr-only">Close</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path></svg></span>';

    $close.addEventListener('click', () => close());

    $title.innerHTML = title;
    $header.appendChild($title);
    $header.appendChild($close);
    $body.appendChild($content);

    $panel.appendChild($header);
    $panel.appendChild($body);

    document.body.appendChild($panel);

    return {
        open,
        close
    };
}